import { Box, useTheme } from '@mui/material';
import {
  mangoFusionPalette,
  SparkLineChart,
  SparkLineChartProps,
} from '@mui/x-charts-pro';
import { useMemo } from 'react';
import PreviousPeriodDataCard, {
  PreviousPeriodDataCardProps,
} from '../previous-period-data-card/previous-period-data-card.component';

type SparklineDataCardProps = PreviousPeriodDataCardProps & {
  sparklineData: any[];
  SparkLineChartProps?: Partial<SparkLineChartProps>;
};

const SparklineDataCard = ({
  sparklineData,
  SparkLineChartProps = {},
  ...rest
}: SparklineDataCardProps) => {
  const theme = useTheme();
  const color = useMemo(
    () => mangoFusionPalette(theme.palette.mode)[1],
    [theme],
  );

  return (
    <PreviousPeriodDataCard
      {...rest}
      slots={{
        afterContent: sparklineData?.length > 0 && (
          <Box sx={{ flexGrow: 1, mt: -2 }}>
            <SparkLineChart
              data={sparklineData}
              height={60}
              area
              margin={{
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
              }}
              curve="natural"
              color={color}
              data-testid="SparklineDataCard.SparkLineChart"
              {...SparkLineChartProps}
            />
          </Box>
        ),
      }}
    />
  );
};
export default SparklineDataCard;
